module.exports = __webpack_public_path__ + "img/7403354.jpg";